/** @tsx tsx */
import React from "react";
import {SidePanel, Button, TextField, Text, TextGroup, TextArea} from "@nike/eds";
import isEmpty from 'lodash/isEmpty';
import ReactJson from 'react-json-view'

const Content = ({selectedRow}) => {
    let resourceJson: {};
    if (isEmpty(selectedRow)) {
        resourceJson = JSON.parse('{}');
    } else {
        resourceJson = JSON.parse(selectedRow?.resource);
    }

    return (
        <form
            id="changelog-content"
            style={{display: "flex", flexDirection: "column", gap: "24px"}}
        >
            <div
                className="eds-grid eds-grid--cols-2"
                style={{alignItems: "end"}}
            >
                <TextField
                    id="Service"
                    label="Service"
                    subtitle=""
                    placeholder="Service Name"
                    value={selectedRow?.service || ''}
                    disabled={true}
                />
                <TextField
                    id="changelog-action"
                    subtitle=""
                    placeholder="Action"
                    label="Action"
                    value={selectedRow?.action || ''}
                    disabled={true}
                />
            </div>
            <div
                className="eds-grid eds-grid--cols-2"
                style={{alignItems: "end"}}
            >
                <TextField
                    id="changelog-author"
                    label="Author"
                    placeholder="Author"
                    value={selectedRow?.author || ''}
                    disabled={true}
                />
                <TextField
                    id="changelog-event-date"
                    label="Event Date"
                    placeholder="Event Date"
                    value={selectedRow?.eventDate || ''}
                    disabled={true}
                />
            </div>
            <div
                className="eds-grid eds-grid--cols-2"
                style={{alignItems: "end"}}
            >
                <TextField
                    id="changelog-type"
                    label="Type"
                    placeholder="Resource Type"
                    value={selectedRow?.resourceType || ''}
                    disabled={true}
                />
                <TextField
                    id="changelog-sub-type"
                    label="Subtype"
                    placeholder="Resource Subtype"
                    value={selectedRow?.resourceSubType || ''}
                    disabled={true}
                />
            </div>
            <TextArea
                id="changelog-notes"
                label="Notes"
                autoResize
                defaultValue={selectedRow?.notes || ''}
                disabled={true}
            />
            <div>
                <TextGroup>
                    <Text font="title-3" as="h2">
                        Details
                    </Text>
                    <ReactJson src={resourceJson}/>
                </TextGroup>
            </div>
        </form>
    );
};

const ChangeLogDetails = ({selectedRow, setSelectedRow}) => {

    return (
        <>
            <SidePanel
                hasScrim
                onDismiss={() => setSelectedRow({})}
                isOpen={!isEmpty(selectedRow)}
                headerSlot={<Text>Changelog Details</Text>}
                footerSlot={
                    <Button
                        form="changelog-details"
                        onClick={() => {
                            setSelectedRow({});
                        }}
                        size="small"
                    >
                        Dismiss
                    </Button>
                }
            >
                <Content selectedRow={selectedRow}/>

            </SidePanel>
        </>
    )
};

export default ChangeLogDetails;
